module.exports = __webpack_public_path__ + "static/media/devices-screen.2ad267d9.png";